import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import {
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

export default function ChaiReportFooter({
  qrValue = "",
  businessInfo: customBusinessInfo = null,
  className = "",
}) {
  const { t } = useTranslation();
  const auth = useSelector((state) => state?.auth);
  const businessInfo = customBusinessInfo || auth?.buisnessInfo || {};
  console.log(auth);

  const phone = businessInfo?.phone || businessInfo?.contact_info || "";
  const whatsapp = businessInfo?.whatsapp || businessInfo?.phone || "";
  const email = businessInfo?.email || "";

  const addressParts = [
    businessInfo?.buildingNumber
      ? `${t("Bldg")} ${businessInfo.buildingNumber}`
      : "",
    businessInfo?.street || businessInfo?.address || "",
    businessInfo?.districtName || "",
    businessInfo?.cityName || businessInfo?.city || "",
    businessInfo?.postalCode
      ? `${t("Postal Code")}: ${businessInfo.postalCode}`
      : "",
    businessInfo?.countryCode || "",
  ].filter(Boolean);

  const address =
    addressParts.length > 0
      ? addressParts.join(", ")
      : businessInfo?.address || "";

  const effectiveQrValue =
    qrValue ||
    address ||
    businessInfo?.address ||
    businessInfo?.city ||
    "Address";

  return (
    <footer
      className={`chai-report-footer ${className}`}
      style={{ breakInside: "avoid", pageBreakInside: "avoid" }}
    >
      <div className="flex items-center justify-between gap-3 text-xs">
        <div className="flex items-center gap-3">
          <div className="h-[46px] w-[46px] shrink-0 p-0.5 border border-gray-300 rounded bg-white shadow-xs flex items-center justify-center">
            <QRCode value={effectiveQrValue} size={40} />
          </div>

          <div className="flex flex-col justify-center gap-1 text-gray-700">
            <div className="flex flex-wrap items-center gap-4 font-semibold text-xs">
              {phone && (
                <span className="inline-flex items-center gap-1.5">
                  <span className="flex h-5 w-5 items-center justify-center text-gray-700">
                    <FaPhoneAlt size={13} />
                  </span>
                  <span className="text-[12px] text-gray-700">{phone}</span>
                </span>
              )}

              {whatsapp && (
                <span className="inline-flex items-center gap-1.5">
                  <span className="flex h-5 w-5 items-center justify-center text-gray-700">
                    <FaWhatsapp size={15} />
                  </span>
                  <span className="text-[12px] text-gray-700">{whatsapp}</span>
                </span>
              )}

              {email && (
                <span className="inline-flex items-center gap-1.5">
                  <span className="flex h-5 w-5 items-center justify-center">
                    <FaEnvelope size={15} />
                  </span>
                  <span className="text-[12px] text-gray-700">{email}</span>
                </span>
              )}
            </div>

            {address && (
              <div className="inline-flex items-center gap-1.5 text-[12px] text-gray-700">
                <span className="flex h-4 w-4 items-center justify-center text-gray-700">
                  <FaMapMarkerAlt size={13} />
                </span>
                <span>{address}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <img
            src="/images/emergency-24-services.png"
            alt="Emergency Services"
            className="h-11 w-auto object-contain"
            style={{ height: "40px", maxHeight: "40px" }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          <div className="h-7 w-[1.5px] bg-gray-300" />
          <img
            src="/images/vision-2030-logo.png"
            alt="Saudi Vision 2030"
            className="h-11 w-auto object-contain"
            style={{ height: "46px", maxHeight: "46px" }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        </div>
      </div>

      {/* <div className="w-full">
        <div className="h-[2.5px] w-full bg-gray-600" />
      </div> */}
    </footer>
  );
}
